import React from "react";
import { Navigate, useParams } from "react-router-dom";
import type { RouteConfig } from "./types";
import TaskListIndex from "@/pages/task-list";

const TaskListRedirect = () => {
	const { AssetIdParam } = useParams();
	return <Navigate to={`/task-list/downday/${AssetIdParam}`} replace />;
};

export const taskListRoutes: RouteConfig[] = [
	{
		path: "/task-list",
		element: <Navigate to="/task-list/downday" replace />,
	},
	{
		path: "/task-list/:AssetIdParam",
		element: <TaskListRedirect />,
	},
	{
		path: "/task-list/downday",
		element: <TaskListIndex />,
	},
	{
		path: "/task-list/downday/:AssetIdParam",
		element: <TaskListIndex />,
	},
];
